<template>
<div class="chapter">
<div class="inner_page">
<p class="crt" id="d7e1636">This collection is comprised of works of fiction. All names, characters, places, and incidents are the product of the authors’ imaginations. Any resemblance to real events or persons, living or dead, is entirely coincidental.</p>
<p class="crt" id="d7e1796">Series concept by Tim McLoughlin and Johnny Temple</p>
<p class="crt" id="d7e1846">Published by Akashic Books<br/>
  © 2006 Akashic Books</p>
<p class="crt" id="d7e1946">Dublin map by Sohrab Habibion<br/>
  Editorial assistance: Emmet Henry and Chris Gough</p>
<p class="crt" id="d7e2036">ISBN-13: 978-1-888451-92-4<br/>
  ISBN-10: 1-888451-92-0<br/>
  Library of Congress Control Number: 2005925466<br/>
  All rights reserved</p>
<p class="crt" id="d7e2256">Akashic Books<br/>
  PO Box 1456<br/>
  New York, NY 10009<br/>
  Akashic7@aol.com<br/>
<a href="http://www.akashicbooks.com" id="d14e164" target="_blank">www.akashicbooks.com</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Brue_ISBN9781936070282_epub_crt4_r1.vue?ee3fc2b6